module.exports = {
  async getUserProfile() {
    const url = `${this.url}/${this.version}/user/profile`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
  async putUserProfile(params) {
    const url = `${this.url}/${this.version}/user/profile`;
    const response = await this.put(url, params, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/user_profile_api.js